import React, { useState, useEffect } from 'react';
import { Form, Button } from 'semantic-ui-react';
import toast from 'react-hot-toast';
import Editor from 'react-simple-wysiwyg';

import { createRfiResponse, updateRfiResponse, deleteRfiResponse } from '~/api/requestForInformation';
import { format } from 'date-fns';

interface RfiResponseFormProps {
  rfi: any; // TODO: type for this
  updateRfiInList: (rfiId: string, updatedResponse: any, action: 'create' | 'update' | 'delete') => void;
}

const RfiResponseForm: React.FC<RfiResponseFormProps> = ({ rfi, updateRfiInList }) => {

  const [response, setResponse] = useState<any>(); // TODO type for this
  const [savedValue, setSavedValue] = useState<any>(); // TODO type for this
  const [inputChanged, setInputChanged] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (!rfi || !rfi.responses || rfi.responses.length === 0) {
      setResponse(undefined);
      setSavedValue(undefined);
      setIsEditing(true);
    } else {
      setResponse(rfi.responses[0]);
      setSavedValue(rfi.responses[0]);
      setIsEditing(false);
    }
  }, [rfi]);

  const handleSave = async () => {
    if (!response) {
      toast.error('Response cannot be empty');
      return;
    }

    if (isProcessing) {
      return;
    }

    if (savedValue) {
      handleUpdate();
    } else {
      handleCreate();
    }

  };

  const handleCreate = async () => {
    try {
      setIsProcessing(true);
      const createdResp = await toast.promise(
        createRfiResponse(rfi.id, { content: response.content }),
        {
          loading: 'Saving response...',
          success: 'Response saved successfully',
          error: 'Failed to save response',
        }
      );
      setSavedValue(createdResp);
      setResponse(createdResp);
      setInputChanged(false);
      setIsEditing(false);
      updateRfiInList(rfi.id, createdResp, 'create');
      setIsProcessing(false);
    } catch (error) {
      console.error('Error creating RFI response:', error);
      setIsProcessing(false);
    }
  };

  const handleUpdate = async () => {
    try {
      setIsProcessing(true);
      const updatedResp = await toast.promise(
        updateRfiResponse(rfi.responses[0].id, { content: response.content }),
        {
          loading: 'Updating response...',
          success: 'Response updated successfully',
          error: 'Failed to update response',
        }
      );
      setSavedValue(updatedResp);
      setResponse(updatedResp);
      setInputChanged(false);
      setIsEditing(false);
      updateRfiInList(rfi.id, updatedResp, 'update');
      setIsProcessing(false);
    } catch (error) {
      console.error('Error updating RFI response:', error);
      setIsProcessing(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this response?')) { // TODO: use a modal instead
      return;
    }
    try {
      await toast.promise(
        deleteRfiResponse(response.id),
        {
          loading: 'Deleting response...',
          success: 'Response deleted successfully',
          error: 'Failed to delete response',
        }
      );
      setResponse(undefined);
      setSavedValue(undefined);
      setIsEditing(true);
      setInputChanged(false);
      updateRfiInList(rfi.id, null, 'delete');
    } catch (error) {
      console.error('Error deleting RFI response:', error);
    }
  };

  const handleCancel = () => {
    setResponse(savedValue);
    setInputChanged(false);
    setIsEditing(false);
  };

  return (
    <>
      {!isEditing && (
        <div className="response-section">
          {/* <strong>{rfi.name}</strong> */}
          <label>{rfi.description}</label>
          <div className="response-text">
            <span dangerouslySetInnerHTML={{ __html: savedValue?.content || 'No answer provided' }} />
          </div>
          {savedValue && (
            <div className="response-date" style={{ marginTop: '-8px', marginBottom: '8px', fontSize: '0.9em', color: '#666' }}>
              Last updated {response?.updatedAt ? format(new Date(response.updatedAt), 'MMM d, yyyy h:mm a') : ''}
            </div>
          )}
          <Button type="submit" primary className="outlined" onClick={() => setIsEditing(true)} icon="edit" content="Edit Response" />
        </div>
      )}

      {isEditing && (
        <Form
          onSubmit={handleSave}
          className="response-section"
        >
          <Form.Field>
            {/* <strong>{rfi.name}</strong> */}
            <label>{rfi.description}</label>
            <Editor
              value={response ? response.content : ''}
              onChange={(e: any) => {
                setResponse((prev: any) => ({
                  ...prev,
                  content: e.target.value,
                }));
                if (e.target.value !== savedValue?.content) {
                  setInputChanged(true);
                }
              }}
              placeholder="Enter your response..."
            />




            {/* <Form.TextArea
              placeholder="Enter your response..."
              value={response ? response.content : ''}
              onChange={handleChange}
            />*/}
          </Form.Field>

          {savedValue && (
            <div className="response-date">
              Last updated {savedValue?.updatedAt ? format(new Date(savedValue.updatedAt), 'MMM d, yyyy h:mm a') : ''}
            </div>
          )}

          <Button
            type="submit"
            primary
            disabled={!response || !inputChanged}
            icon="send"
          >
            {isProcessing ? (
              <span>
                <i className="send icon" />
                Sending...
              </span>
            ) : (
              <span>
                <i className="send icon" />
                Send to Seller
              </span>
            )}
          </Button>
          {savedValue && (
            <Button
              type="button"
              primary
              className="outlined"
              onClick={handleCancel}
              icon="x"
              content="Cancel"
              style={{ marginLeft: 8 }}
            />
          )}
          {savedValue && (
            <Button
              type="button"
              primary
              className="outlined"
              onClick={handleDelete}
              style={{ marginLeft: 8 }}
              icon="trash"
              content="Delete Response"
            />
          )}
        </Form>
      )}
    </>

  );
};
export default RfiResponseForm;